import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  Button,
  ListGroup,
  ListGroupItem,
  Progress,
  Alert
} from "shards-react";
import ButtonGroups from "../components-overview/ButtonGroups";

const UserDetails = ({ userDetails }) => (
  <Card small className="mb-4 pt-3">
    <CardHeader className="border-bottom text-center">
      <div className="mb-3 mx-auto">
        <img
          className="rounded-circle"
          src={userDetails.avatar}
          alt={userDetails.name}
          width="110"
        />
      </div>
      <h4 className="mb-0">{userDetails.name}</h4>
      <span className="text-muted d-block mb-2">{userDetails.jobTitle}</span>
      <a href="https://twitter.com/Vinit_Shahdeo" target="_blank">
      <Button pill outline size="sm" className="mb-2">
        <i className="material-icons mr-1">person_add</i> Follow on Twitter
      </Button>
      </a>
    </CardHeader>
    <ListGroup flush>
      
      
     
      <ListGroupItem className="p-4">
        <strong className="text-muted d-block mb-2 text-center">
          {userDetails.metaTitle}
        </strong>
        <span>{userDetails.metaValue}</span>
      </ListGroupItem>
      <ListGroupItem className="p-4 text-center">
      <a href="https://fayz.in/stories/s/1522/0/?ckt_id=ZGL1ZGVk&title=story_of_vinit_shahdeo" target="_blank">
      <Button outline theme="accent" size="sm">
            <i className="material-icons">share</i> Learn more
          </Button>
          </a>
      </ListGroupItem>
      
    </ListGroup>
  </Card>
  
);

UserDetails.propTypes = {
  /**
   * The user details object.
   */
  userDetails: PropTypes.object
};

UserDetails.defaultProps = {
  userDetails: {
    name: "Vinit Shahdeo",
    avatar: require("./../../images/vinit-shahdeo.jpg"),
    jobTitle: "Bangalore, India",
    metaTitle: "About",
    metaValue:
      "A graduate from VIT Vellore, currently working as Software Engineer at Postman. Never says 'No' to Coffee, Pizza and late night rides."
  }
};

export default UserDetails;
